import { Component, Prop, Vue } from "vue-property-decorator";
import MagicBlock from "./MagicBlock.vue";
import RuntimeFragment from "./RuntimeFragment";

@Component({
  name: "RuntimeComponent",
  components: { MagicBlock, RuntimeFragment }
})
export default class RuntimeComponent extends Vue {
  @Prop({
    type: Object
  })
  private origin!: any;

  @Prop({
    type: String
  })
  private template!: string;

  public getFormData(): Promise<any> {
    return Promise.resolve(true);
  }

  render(createElement: any) {
    if (this.template) {
      const compiler = Vue.compile(this.template);
      this.$options.staticRenderFns = compiler.staticRenderFns;
      return compiler.render.call(this, createElement);
    } else {
      return createElement(this.$slots.default);
    }
  }
}

